import React from "react";
import qrImageSrc from "../../assets/qr-vale.png";
import "./FloatingQR.css";

export default function FloatingQR() {
  const [isVisible, setIsVisible] = React.useState(true);
  const [hasImageError, setHasImageError] = React.useState(false);

  if (!isVisible || hasImageError) {
    return null;
  }

  return (
    <div className="floating-qr-container">
      <button
        className="floating-qr-close"
        onClick={() => setIsVisible(false)}
        aria-label="Cerrar QR"
      >
        ×
      </button>
      <img
        src={qrImageSrc}
        alt="QR Code"
        className="floating-qr-image"
        onError={() => setHasImageError(true)}
      />
      <p className="floating-qr-text">Escanea el código</p>
    </div>
  );
}
